// extracted by mini-css-extract-plugin
module.exports = {"rainbow":"Shop_rainbow__TXpXI","hero":"Shop_hero__to5yE","card":"Shop_card__wol6L"};